import React from 'react'
import { NavigatorIcon } from "../../Assest/icons";
import { defaultLogo } from '../../env';
import { useSelector } from 'react-redux';
import jwtEncode from 'jwt-encode';

const AppNavigator = ({ applications }) => {
    const userData = useSelector(state => state.userSlice);

    const redirectApplication = (link) => {
        if (userData?.token && link) {
            const payload = { token: userData?.token };
            const token = jwtEncode(payload, "");

            if (link.includes("apps.simulanis.io")) {
                const newUrl = `${link}`;
                window.location.href = newUrl;

            } else {
                const newUrl = `${link}?referrer=${token}`;
                window.location.href = newUrl;
            }

        }
    }
    return (
        <>
            <div className="dropdown navigator">
                <div className="profile-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    <NavigatorIcon />
                </div>
                <div className="dropdown-menu">
                    <div className='menu-long'>
                        <div className={applications.length > 2 ? 'menubg extraspace' : 'menubg'}>

                            {applications.map((e, index) => {
                                // if (e.uuid === applicationId) return null;
                                return <div  key={e.uuid} className='appshere'
                                onClick={() => redirectApplication(e.channel?.origins[0]?.url)}
                                >
                                    <img src={e.icon || defaultLogo}
                                        onError={(e) => {
                                            e.target.src = defaultLogo
                                            e.onerror = null;
                                        }}
                                        alt=''
                                        referrerPolicy={'no-referrer'}
                                    />
                                    <p>{e.name}</p>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AppNavigator